import mori from 'mori';
import { buildHeader } from './';

/**
 * [getAgColumns description]
 * @TODO: finish documenting this out
 * @param  {[type]} headers          [description]
 * @param  {[type]} distributions    [description]
 * @param  {[type]} linkColumn       [description]
 * @param  {[type]} linkTarget       [description]
 * @param  {[type]} linkContext      Used when building the selectedRows tree
 *                                   for inter-indicator linking
 * @param  {[type]} type             [description]
 * @param  {[type]} timeframes       [description]
 * @param  {[type]} trend            [description]
 * @param  {[type]} baseDistribution [description]
 * @param  {[type]} mapBaseColumn    [description]
 * @param  boolean geoMulti          Stating whether the table is of the Geo-Multi type
 * @param  string baseContext        Title of the first column of the table.
 * @param  integer tableIndex        Number identifying which table this is in a page with many tables
 * @return {[type]}                  [description]
 */
export default function(
  headers,
  distributions,
  linkColumn,
  linkTarget,
  linkContext,
  type,
  timeframes,
  trend,
  baseDistribution,
  mapBaseColumn,
  geoMulti,
  baseContext,
  tableIndex
) {
  // Pluck distribution names from the selected distributions array
  const distributionNames = mori.set(mori.map(
    (characteristic) => mori.get(characteristic, 'characteristic'),
    distributions
  ));
  const headerGroups = mori.set(mori.map(
    (group) => mori.get(group, 'headerGroup', false),
    distributions
  ));

  // Map selected headers by distribution name and type
  const selectedHeaders = mori.filter(
    (header) => {
      return mori.get(header, 'idx') === 0 ||
        ((mori.hasKey(header, 'headerGroup') &&
          mori.get(header, 'headerGroup', null) !== null) ?
          mori.hasKey(distributionNames, mori.get(header, 'characteristic')) &&
          mori.hasKey(headerGroups, mori.get(header, 'headerGroup')) :
          mori.hasKey(distributionNames, mori.get(header, 'characteristic'))
        ) &&
        (!type ||
          type.type === 'default' ||
          type.label === mori.get(header, 'label'));
    },
    headers
  );

  // Build the header object required by ag-grid
  let columnDefs;
  const initialColumn = buildHeader(
    mori.first(selectedHeaders),
    linkColumn,
    linkTarget,
    linkContext,
    mori.first(timeframes),
    undefined,
    baseDistribution,
    mapBaseColumn,
    geoMulti,
    baseContext,
    tableIndex,
    selectedHeaders
  );

  // clusters the timeframe header groups
  if (trend) {
    columnDefs = mori.into(
      mori.vector(initialColumn),
      mori.map(
        (timeframe) => mori.hashMap(
          'headerName', mori.first(timeframe),
          'children', mori.into(
            mori.vector(),
            mori.map(
              (header) => buildHeader(
                header,
                linkColumn,
                linkTarget,
                linkContext,
                timeframe,
                trend,
                baseDistribution,
                mapBaseColumn,
                geoMulti,
                baseContext,
                tableIndex
              ),
              mori.rest(selectedHeaders)
            )
          )
        ),
        mori.reverse(timeframes)
      )
    );
  } else {
    const isGrouped = mori.some(
      (header) => mori.hasKey(header, 'headerGroup'),
      mori.rest(selectedHeaders)
    );
    if (!isGrouped) {
      columnDefs = mori.into(
        mori.vector(initialColumn),
        mori.mapcat((header) =>
          mori.into(mori.vector(), mori.map((timeframe) =>
            buildHeader(
              header,
              linkColumn,
              linkTarget,
              linkContext,
              timeframe,
              trend,
              baseDistribution,
              mapBaseColumn,
              geoMulti,
              baseContext,
              tableIndex
            ),
            mori.reverse(timeframes))
          ),
          mori.rest(selectedHeaders)
        )
      );
    } else {
      const groupedHeaders = [];
      columnDefs = mori.into(
        mori.vector(initialColumn),
        mori.mapcat((header) => {
          const headerGroup = mori.get(header, 'headerGroup');
          if (!headerGroup) {
            return mori.vector(
              buildHeader(
                header,
                linkColumn,
                linkTarget,
                linkContext,
                mori.first(timeframes),
                trend,
                baseDistribution,
                mapBaseColumn,
                geoMulti,
                baseContext,
                tableIndex
              )
            );
          }

          if (groupedHeaders.indexOf(headerGroup) < 0) {
            groupedHeaders.push(headerGroup);
            return mori.vector(
              mori.hashMap(
                'headerName', headerGroup,
                'children', mori.into(
                  mori.vector(),
                  mori.map((headerItem) => {
                    return buildHeader(
                      headerItem,
                      linkColumn,
                      linkTarget,
                      linkContext,
                      mori.first(timeframes),
                      trend,
                      baseDistribution,
                      mapBaseColumn,
                      geoMulti,
                      baseContext,
                      tableIndex,
                      null,
                      headerGroup,
                      mori.filter((item) =>
                        mori.get(item, 'headerGroup') === headerGroup,
                        mori.rest(selectedHeaders)
                      )
                    );
                  }, mori.filter((item) =>
                    mori.get(item, 'headerGroup') === headerGroup,
                    mori.rest(selectedHeaders)
                  )
                  ))
              )
            );
          }
        }, mori.rest(selectedHeaders))
      );
    }
  }

  return columnDefs;
}



/** WEBPACK FOOTER **
 ** ../~/eslint-loader!./js/services/table/getAgColumns.js
 **/